export const INITIAL_SKELETON_COUNT = 5;
export const FOOTER_SKELETON_COUNT = 2;
